import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ReactDubaiNativeIcon,
  ReactDubaiDevIcon,
  ReactDubaiMainIcon,
  ReactDubaiOptIcon,
  ReactDubaiIntIcon,
  ReactDubaiSuppIcon,
} from "../../../app-constants";

const StackItem = [
  {
    icon: ReactDubaiNativeIcon,
    title: "React Native App Design",
    description:
      "Raise your app's aesthetics with TekRevol's complete design services. From creating wireframes and models to providing spectacular user interfaces, our expert React Native app developers use tools like Atom, Nuclide, Flow, and Visual Studio Code for an effortless user experience.",
  },
  {
    icon: ReactDubaiDevIcon,
    title: "React Native App Development",
    description:
      "Experience the highest quality Android and iOS development with our advanced react backend frameworks, encompassing Node.js, Kinvey, Express.js, Django, and Firebase. Our DevOps culture and agile methodologies ensure excellent results, guaranteeing a remarkable return on investment.",
  },
  {
    icon: ReactDubaiMainIcon,
    title: "React Native App Maintenance",
    description:
      "Launch your enterprise or startup with our consulting and maintenance services. It doesn't matter what business niche you possess; our virtual team of React Native app developers and consultants quickly adjusts to variations, fixes bugs, and closes loopholes without needing devoted workspaces or hiring permanent staff.",
  },
  {
    icon: ReactDubaiOptIcon,
    title: "React Native App Optimization",
    description:
      "Enhance your app's performance and user engagement with TekRevol's customized optimization services. Our team conducts detailed analyses, finds holdups, and applies planned improvements to increase speed, receptiveness, and overall user fulfillment. Whether it's restructuring code or refining UI/UX elements, we guarantee your app provides an excellent experience on every device.",
  },
  {
    icon: ReactDubaiIntIcon,
    title: "React Native App Integration",
    description:
      "Effortlessly integrate third-party services and APIs into your React Native application with TekRevol's skilled integration solutions. From payment gateways to social media platforms, our developers have the knowledge to connect your app with the tools and services that improve its working and deliver added value to your users. With careful attention to detail, we warrant impeccable integration without compromising security or stability.",
  },
  {
    icon: ReactDubaiSuppIcon,
    title: "React Native App Support",
    description:
      "Guarantee the constant success of your app with TekRevol's complete support services. Our steadfast team of support experts is available at any time to resolve issues, answer queries, and provide guidance whenever you need it. Whether it's troubleshooting technical problems or delivering user assistance, we are committed to keeping your app functioning effortlessly and your users happy.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Raise the Standard of App Building with Our Premier React Native
              Solutions
            </h2>
            <p className="impro_para">
              Grow your business with our user-centric React Native app
              development services, precisely created for a competitive edge.
              Our expert React Native developers assure a flawless user
              experience while building feature-rich mobile apps. Dive into our
              collection of React Native App Development services and let
              innovation regulate your success.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
